import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { alertsGet } from "@/store/alerts";

import AppText from "@/components/AppText";
import AppInput from "@/components/AppInput";
import AppBox from "@/components/AppBox";
import AdminAlertsTable from "@/components/Tables/AdminAlertsTable";
import AppLoader from "@/components/AppLoader";

const Alerts: React.FC = () => {
  const dispatch = useAppDispatch();

  const { alerts, status } = useAppSelector((state: any) => state.alerts);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const [filteredAlerts, setFilteredAlerts] = useState<typeof alerts>([]);

  useEffect(() => {
    dispatch(alertsGet());
  }, [dispatch]);

  useEffect(() => {
    if (alerts.length) {
      const newList = alerts.filter((item: any) => {
        const query = searchQuery.toLowerCase();
        return (
          item.type.toLowerCase().includes(query) ||
          item.title.toLowerCase().includes(query) ||
          item.message.toLowerCase().includes(query)
        );
      });
      setFilteredAlerts(newList);
    }
  }, [alerts, searchQuery]);

  const handleChangeInput = (value: string) => {
    setSearchQuery(value);
  };

  return (
    <AppBox column fullWidth gap={6}>
      {/* Header and Search */}
      <AppBox
        className="flex justify-between mb-4 lg:flex-row flex-col gap-4 lg:gap-0 items-center"
      >
        <AppText variant="h2">System Alerts</AppText>

        <AppBox className="w-full sm:w-80">
          <AppInput
            placeholder="Type to search..."
            fullWidth
            onChange={(e) => handleChangeInput(e.target.value)}
            value={searchQuery}
          />
        </AppBox>
      </AppBox>

      {/* Loader or Alerts Table */}
      {status === "loading" ? (
        <AppBox className="flex justify-center">
          <AppLoader />
        </AppBox>
      ) : (
        <AdminAlertsTable tableRows={filteredAlerts} />
      )}
    </AppBox>
  );
};

export default Alerts;